export const mensajesChat = {
  // NewConversationModal.vue — start a new WhatsApp conversation
  newConversation: {
    nameTooShort: "Podaj nazwę, pod którą chcesz być rozpoznawany.",
    saveNameError: "Nie udało się zapisać nazwy firmy.",
    started: "Rozmowa rozpoczęta.",
    sent: "Wiadomość wysłana.",
    startError: "Nie udało się rozpocząć rozmowy.",
    titleConnect: "Podłącz swój WhatsApp",
    titleName: "Nazwa Twojej firmy",
    titleNew: "Nowa rozmowa",
    subtitleConnect: "Wymagane, aby móc napisać jako pierwszy",
    subtitleName: "Tę nazwę zobaczą odbiorcy jako nadawcę wiadomości",
    subtitleNew: "Napisz na dowolny numer na WhatsApp",
    close: "Zamknij",
    senderStripPre: "Zostanie wysłane jako",
    change: "Zmień",
    connectBody:
      "Aby napisać jako pierwszy, wiadomość musi wyjść z <strong>Twojego własnego numeru WhatsApp Business</strong>. Przy wspólnym numerze WACheckin odbiorcy widzieliby telefon, który nie należy do Pana/Pani, i nie moglibyśmy przedstawić Pana/Pani firmy pod jej nazwą.",
    connectItem1: "Napisz na dowolny numer, z rezerwacją lub bez",
    connectItem2: "Jako nadawca pojawia się nazwa Twojej firmy",
    connectItem3: "Odpowiedzi trafiają do tej samej skrzynki odbiorczej",
    connectFoot: "Wystarczy podłączyć raz, w sekcji Integracje → WhatsApp.",
    previewLabel: "Tak to zobaczą",
    previewGreeting: "Cześć 👋",
    previewFromPre: "Wiadomość wysyła",
    previewFromPost: ".",
    previewCtaPre: "Mamy dla Pana/Pani wiadomość. Wystarczy odpowiedzieć",
    previewOk: "Ok",
    previewCtaPost: "i od razu ją wyślemy.",
    fallbackBusiness: "Twoja firma",
    nameLabel: "Nazwa firmy",
    namePlaceholder: "Pensjonat Pod Lipami",
    nameHelp:
      "Zapisuje się w sekcji Agent AI → Nowe rezerwacje i można ją zmienić tam albo tutaj w dowolnej chwili.",
    recipientLabel: "Odbiorca",
    messageLabel: "Wiadomość",
    messagePlaceholder: "Napisz wiadomość…",
    cancelSoft: "Nie teraz",
    cancel: "Anuluj",
    connectBtn: "Podłącz WhatsApp",
    continueBtn: "Dalej",
    sendBtn: "Wyślij wiadomość",
  },

  // MessageTranslate.vue — per-message translation in chat bubbles
  translate: {
    // BarraTraduccion.vue — pasek tłumacza czatu (automat + podgląd)
    off: "Tłumaczenie automatyczne wyłączone",
    on: "Tłumaczę",
    turnOn: "Tłumacz to, co przychodzi, i pokaż podgląd tego, co piszesz",
    turnOff: "Wyłącz tłumaczenie automatyczne",
    guestWrites: "gość pisze po {idioma}",
    nothingToDo: "Nie ma czego tłumaczyć: gość pisze po {idioma}",
    youRead: "Czytasz to po",
    willBeSentIn: "to, co napiszesz, wyjdzie po",
    pickOutgoing: "W jakim języku do niego dotrze",
    theirs: "jego",
    willArriveAs: "Dotrze tak, po {idioma}:",
    sendIn: "Wyślij po {idioma}",
    cancel: "Anuluj",
    discard: "Odrzuć",
    enterSends: "Enter wysyła",
    translating: "Tłumaczę…",
    translate: "Przetłumacz",
    viewTranslation: "Pokaż tłumaczenie",
    viewOriginal: "Pokaż oryginał",
    translated: "Przetłumaczone",
    copy: "Kopiuj",
    copied: "Skopiowano",
    error: "Nie udało się przetłumaczyć. Spróbuj ponownie.",
  },

  // Phone.vue — WhatsApp-style chatbot preview
  phone: {
    online: "Online",
    today: "Dzisiaj",
    sampleQuestion: "O której godzinie jest check-in?",
    answerPlaceholder: "Wpisz tutaj swoją odpowiedź...",
    inputPlaceholder: "Napisz wiadomość...",
  },

  // selectorTypeIframe.vue — subscription billing period selector
  billing: {
    selectPeriod: "Wybierz okres",
    selectPeriodHint: "Wybierz sposób płatności",
    monthly: "Miesięcznie",
    annual: "Rocznie",
  },

  // GrupoDestinatarios.vue — escribir a un grupo de huéspedes
  grupo: {
    modeLabel: "Do kogo piszesz",
    modeOne: "Pojedyncza wiadomość",
    modeGroup: "Wiadomość masowa",
    allOtas: "Wszystkie",
    needsWhatsapp: "Połącz swojego WhatsAppa, aby użyć tej drogi",
    connectNow: "Połącz",
    varsLabel: "Zmienna",
    vars: {
      nombre: "Imię gościa",
      alojamiento: "Nazwa obiektu",
      entrada: "Data zameldowania",
      salida: "Data wymeldowania",
      codigo: "Kod rezerwacji",
    },
    remove: "Usuń",
    oneEach: "Każdy gość otrzyma to raz, pierwszą dostępną drogą.",
    noContact: "1 bez możliwości kontaktu | {count} bez możliwości kontaktu",
    otaLabel: "Która OTA",
    emoji: "Emoji",
    attach: "Załącz plik",
    noFileOta: "Plik nie przechodzi przez OTA",
    previewLabel: "Jak to będzie wyglądać",
    fileTooBig: "„{name}” waży {size} MB, a limit WhatsAppa dla tego typu to {max} MB",
    fileNotAllowed: "Dozwolone są tylko obrazy (JPG, PNG, GIF), PDF i wideo MP4: WhatsApp nie odtwarza innych formatów.",
    attachHint: "Obrazy i PDF do 10 MB · wideo MP4 do 15 MB",
    channelLabel: "Którą drogą",
    channels: { whatsapp: "WhatsApp", email: "E-mail", ota: "OTA" },
    groupLabel: "Którzy goście",
    groups: {
      alojados: "Obecnie na miejscu",
      entran_hoy: "Przyjeżdżają dziś",
      entran: "Wkrótce przyjazd",
      salen: "Wyjeżdżają dziś",
    },
    withinPre: "w ciągu najbliższych",
    withinPost: "dnia | dni",
    empty: "Obecnie nie ma gości w tej grupie.",
    reachOf: "z {total} ją otrzyma | z {total} ją otrzymają | z {total} ją otrzyma",
    queuedSilently: "1 nie otrzyma dziś powiadomienia: miał już jedno oczekujące | {count} nie otrzyma dziś powiadomienia: mieli już jedno oczekujące",
    noChannel: {
      whatsapp: "1 bez telefonu | {count} bez telefonu",
      email: "1 bez e-maila | {count} bez e-maila",
      ota: "1 bez wątku OTA | {count} bez wątku OTA",
    },
    billed: "1 rozmowa WhatsApp jest płatna | {count} rozmów WhatsApp jest płatnych",
    showList: "Pokaż odbiorcę | Pokaż {count} odbiorców",
    hideList: "Ukryj listę",
    noName: "Bez nazwiska",
    states: {
      directo: "dotrze",
      plantilla: "zaproszenie",
      en_cola: "miał już oczekujące",
      sin_telefono: "bez telefonu",
      sin_correo: "bez e-maila",
      sin_hilo_ota: "bez wątku",
      sin_contacto: "brak kontaktu",
    },
    sending: "Wysyłanie do 1 gościa | Wysyłanie do {count} gości",
    sendGroup: "Wyślij do 1 gościa | Wyślij do {count} gości",
    historial: {
      providerId: "Identyfikator u dostawcy. Służy do odszukania wiadomości w konsoli SES.",
      sentMeans: "„Wysłano” znaczy, że dostawca ją przyjął. To, czy gość ją przeczyta i czy nie trafi do spamu, już od nas nie zależy.",
      estados: {
        enviando: "Wysyłanie",
        enviado: "Wysłano",
        en_cola: "W kolejce",
        fallo: "Nie wysłano",
        sin_contacto: "Brak kontaktu",
      },
      title: "Wysyłki grupowe",
      subtitle: "Co wysłano, do kogo i co się z tym stało",
      empty: "Nie wysłałeś jeszcze żadnej wiadomości grupowej.",
      error: "Nie udało się wczytać historii.",
      sentBy: "przez {quien}",
      running: "W trakcie",
      back: "Wstecz",
      messageLabel: "Wiadomość",
      recipientsLabel: "Odbiorcy",
      colName: "Gość",
      colVia: "Kanał",
      colDest: "Wysłano do",
      colState: "Wynik",
      openChat: "Otwórz",
      attachment: "Załącznik: {nombre}",
      close: "Zamknij",
      reached: "{enviados} z {total}",
      noOne: "Bez nazwiska",
    },
  },
};
